import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import { DataFilterPowiadomieniaService } from 'src/app/services/data-filter-powiadomienia.service';
import {CodeType} from '../../../models/powiadomienie.model';
import { DestroyComponent } from 'src/app/components/destroy/destroy.component';
import { takeUntil } from 'rxjs/operators';
import { PowiadomienieFiltr } from 'src/app/models/powiadomienie-filtr.model';

@Component({
  selector: 'app-powiadomienia-filtry',
  templateUrl: './powiadomienia-filtry.component.html',
  styleUrls: ['./powiadomienia-filtry.component.scss']
})
export class PowiadomieniaFiltryComponent extends DestroyComponent implements OnInit {
  dataZdarzeniaDoMin: Date = null;
  togglePanelFiltry = false;

  constructor(
    private fb: FormBuilder,
    public dataFilterService: DataFilterPowiadomieniaService
  ) {
    super();
  }

  form: FormGroup;
  typZdarzenia = [
    {name: 'Wszystkie', value: []},
    {name: 'Zarejestrowano sprawę na wniosek', value: [CodeType.ZAREJESTROWANO_SPRAWE_NA_WNIOSEK]},
    {name: 'Zarejestrowano sprawę z urzędu', value: [CodeType.ZAREJESTROWANO_SPRAWE_Z_URZEDU]},
    {name: 'Pojawił się wpis w rejestrze', value: [CodeType.POJAWIL_SIE_WPIS_W_REJESTRZE]},
    {name: 'Zbliża się termin wygaśnięcia subskrypcji', value: [CodeType.ZBLIZA_SIE_TERMIN_WYGASNIECIA_SUBSKRYPCJI]},
    {name: 'Subskrybcja została zakończona', value: [CodeType.SUBSKRYPCJA_ZOSTALA_ZAKONCZONA]},
  ];


  ngOnInit(): void {
    this.initForm();
    this.initValidation();
  }

  initForm(): void {
    this.form = this.fb.group({
      registrationFrom: [],
      registrationTo: [],
      krs: [''],
      subjectName: [''],
      type: [null],
      showAll: [false]
    });

    const value = this.dataFilterService.dataFilter.getValue();
    this.form.patchValue(value);
    if(value?.type && value.type?.length === 1) {
      this.form.get('type').setValue(this.typZdarzenia.find(x => x.value[0] === +value.type[0]));
    }
  }

  filter(): void {
    this.dataFilterService.runFilter(PowiadomienieFiltr.filtrKey, this.form.value);
  }

  clear(): void {
    this.form.reset();
    setTimeout(() => {
      this.form.get('showAll').setValue(false);
      this.form.get('type').setValue([]);
      this.filter();
    });
  }

  private initValidation(): void {
    this.form.get('registrationFrom')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.dataZdarzeniaDoMin = new Date(value);
        const dataDo = new Date(this.form?.get('registrationTo').value);
        if (this.dataZdarzeniaDoMin.getTime() > dataDo.getTime()) {
          this.form?.get('registrationTo').setValue(null);
        }
      });
  }
}
